.bo{flex-wrap:wrap;}